<template>
  <span
    :class="{
      'competition-tag-icon': !!competitionTag.icon,
      'competition-tag-chip': !competitionTag.icon,
      [competitionTag.style.class]: true
    }"
    :aria-label="competitionTag.ariaLabel || undefined"
    ><v-icon
      v-if="competitionTag.icon"
      :color="competitionTag.style.color"
      size="16px"
      class="ma-auto"
      >{{ competitionTag.icon }}</v-icon
    >
    <template v-else>{{ competitionTag.iconText }}</template>
  </span>
</template>
<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "AppShowCompetitionTag",
  props: {
    competitionTag: {
      type: Object,
      required: true
    }
  }
});
</script>
<style scoped lang="scss">
.competition-tag-icon {
  border-radius: 1em;
  display: inline-flex;
  padding: 4px;
  margin: 0 1px;
}
.competition-tag-chip {
  font-size: 11px;
  border-radius: 50%;
  padding: 4px;
  font-weight: bold;
  margin: 0 2px;

  min-width: 24px;
  height: 24px;
  display: inline-block;
  text-align: center;
}
</style>
